export default __webpack_public_path__ + "static/media/red-donate.5ea8a460.png";